import {item} from './item';

export const query = `query getProductByIdWithoutMandatory($productId: String!, $withOptions: Boolean = true, $withPriceRange: Boolean = false) {
  catalog {
    product(productId: $productId) {
      ${item}
    }
  }
}
`;
